module.exports = __webpack_public_path__ + "static/media/no-image_White.63c6ef90.webp";